<template>
  <NavbarOne />
  <PageBanner />
  <ProductDetails />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/ProductDetails/PageBanner.vue";
import ProductDetails from "@/components/ProductDetails/index.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "ProductDetailsPage",
  components: {
    NavbarOne,
    PageBanner,
    ProductDetails,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "تفاصيل الاشتراك | باقات IPTV وقنوات بجودة HD و4K",
      meta: [
        {
          name: "description",
          content:
            "تعرف على تفاصيل اشتراك IPTV، المميزات، القنوات المتاحة، الأجهزة المدعومة، جودة البث، ومدة الاشتراك لاختيار الباقة الأنسب لك.",
        },
        {
          name: "keywords",
          content:
            "تفاصيل اشتراك IPTV, باقة IPTV, قنوات عربية, قنوات رياضية, IPTV HD, IPTV 4K, اشتراك قنوات",
        },
        {
          property: "og:title",
          content: "تفاصيل الاشتراك | باقات IPTV",
        },
        {
          property: "og:description",
          content:
            "اكتشف تفاصيل ومميزات باقات IPTV واختر الاشتراك المناسب لمشاهدة القنوات والأفلام والمسلسلات.",
        },
        {
          property: "og:type",
          content: "product",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/product-details",
        },
      ],
    });
  },
});
</script>